import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Logistic App">
                <h1>Best Logistic Software Development Company in USA</h1>
              </div>
              <div className="banner_content">
                <p>
                  We create logistic software for businesses to manage
                  warehousing, storage, and streamline logistic operations. Our
                  logistics software development services are designed to help
                  your company improve all aspects of the logistics and
                  transportation industry. Collaborate with us to develop
                  feature-rich software for delivery management and shipping.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
